import { render, staticRenderFns } from "./AgreementList.vue?vue&type=template&id=e5b48b1e&"
import script from "./AgreementList.vue?vue&type=script&lang=js&"
export * from "./AgreementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports